import {FeatureCollection, MultiPoint} from "geojson";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {Style, Icon} from "ol/style";
import {neighbourLayer} from "@ui/services/common/layers";
import {getAzimuth} from "@ui/common/utils";
// import popupService from "@ui/services/PopupService" // @todo перенес PopupService в features, для соседей надо будет сделать другой PopupService

export interface INeighbourService{
	updateNeighbours(data: FeatureCollection<MultiPoint>): void
	toggleLayer(visible: boolean): void
}

class NeighbourService implements INeighbourService {

	updateNeighbours(data: FeatureCollection<MultiPoint>) {
    // @todo перенес часть функционала из movement.ts, который касается попапа. Не проверил, так что он может не работать
    const source = neighbourLayer.getSource()
    if (source) {
      source.clear();
      source.addFeatures(
        data.features.map(({geometry: {coordinates}, id, properties = {}}) => {
          const [A, B] = [coordinates[1].reverse(), coordinates[0].reverse()]
          const neighbour = new Feature<Point>({geometry: new Point(B)})
          neighbour.setId(id)
          neighbour.setProperties({properties})
          neighbour.setStyle(new Style({
            image: new Icon({
              scale: [1.2, 1.2],
              rotation: A ? getAzimuth(A, B) : 0,
              src: '/neighbourboard.svg',
            })
          }))
          // neighbour.set("onClick", () => popupService.showPopup(neighbour, this.constructPopupContent(neighbour.getProperties())))
          return neighbour;
        })
      )
    }

    // const popupFeature = popupService.getPopupFeature()
    // if (popupFeature) {
    //   neighbourLayer.getSource()?.getFeatures().forEach(feature => {
    //     if (popupFeature.getId() === feature.getId()) {
    //       popupService.showPopup(feature, this.constructPopupContent(feature.getProperties()))
    //     }
    //   })
    // }
	}

	toggleLayer(visible: boolean): void {
		neighbourLayer.setVisible(visible)
	}

  constructPopupContent(props: {[k: string]: any}): string {
    return "Not implemented!"
  }
}
export default new NeighbourService() as INeighbourService
